import { INTERNAL_SUPPLIER } from '../constants';

export const hideInternalSupplierVendor = (supplier: string) => {
  const shouldReplaceWithSap = supplier === INTERNAL_SUPPLIER || !supplier;
  const hideInternalSupplierVendor = shouldReplaceWithSap ? 'SAP' : supplier;
  return hideInternalSupplierVendor;
};
